import React from 'react';
import { Text, Select, Button, Flex, Grid } from '@mantine/core';
import { DATE_RANGE_PRESET_VALUES } from '../hooks';
import { t } from 'i18next';
import dayjs from 'dayjs';

interface DateRangeSelectorProps {
  dateRangePreset: string;
  onDateRangeChange: (value: string | null) => void;
  customDateRange: [Date | null, Date | null];
  setShowCustomDateModal: (show: boolean) => void;
  dateRangePresets: { value: string; label: string }[];
}

export const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  dateRangePreset,
  onDateRangeChange,
  customDateRange,
  setShowCustomDateModal,
  dateRangePresets
}) => {
  return (
    <Grid align="center">
      <Grid.Col span={4}>
        <Text fw={600}>{t('graph.dateRange')}:</Text>
      </Grid.Col>
      <Grid.Col span={8}>
        <Flex align="center" gap="md">
          <Select
            data={dateRangePresets}
            value={dateRangePreset}
            onChange={onDateRangeChange}
            w="100%"
            maw={250}
          />
          {dateRangePreset === DATE_RANGE_PRESET_VALUES.CUSTOM && (
            <>
              <Text size="sm">
                {customDateRange[0] && customDateRange[1] 
                  ? `${dayjs(customDateRange[0]).format('YYYY-MM-DD')} - ${dayjs(customDateRange[1]).format('YYYY-MM-DD')}`
                  : t('graph.selectCustomDates')}
              </Text>
              <Button 
                variant="outline" 
                size="xs"
                onClick={() => setShowCustomDateModal(true)}
              >
                {t('common.change')}
              </Button>
            </>
          )}
        </Flex>
      </Grid.Col>
    </Grid>
  );
}; 